var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseTransparency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.87,
    height: 106.785,
    viewBox: "0 0 101.87 106.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "homepageStep1.1",
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_3",
    "data-name": "Soustraction 3",
    d: "M89.043,106.784H0V38.367L44.522,0,64.557,17.266V12.149H74.945V26.217l14.1,12.15v68.416ZM44.522,9.608h0L7.46,41.109v59.076H81.567V41.109L44.522,9.609Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M0,106.783v-5.94H44.521v5.94Zm0-5.94V38.366L44.521,0V8.748L6.8,40.808v60.036Z",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "breathable",
    transform: "translate(101.87 39.079) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.757,10.131A1.952,1.952,0,0,0,3.5,9.782L5.147,7.647a10.577,10.577,0,0,0,1.407,4.785,6.673,6.673,0,0,1,0,6.668L5.4,21.1a14.59,14.59,0,0,0,0,14.579,1.951,1.951,0,1,0,3.378-1.955,10.679,10.679,0,0,1,0-10.669l1.158-2a10.587,10.587,0,0,0,0-10.578A6.652,6.652,0,0,1,9.063,7.7l1.612,2.084a1.952,1.952,0,1,0,3.088-2.388L8.629.758a1.951,1.951,0,0,0-3.087,0L.408,7.394A1.952,1.952,0,0,0,.757,10.131Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.757,26.523a1.953,1.953,0,0,1,2.738.349l1.651,2.135a10.575,10.575,0,0,1,1.407-4.785,6.674,6.674,0,0,0,0-6.669l-1.157-2A14.589,14.589,0,0,1,5.4.975,1.951,1.951,0,1,1,8.775,2.93a10.679,10.679,0,0,0,0,10.669l1.158,2a10.587,10.587,0,0,1,0,10.578,6.663,6.663,0,0,0-.869,2.78l1.612-2.084a1.952,1.952,0,1,1,3.087,2.389L8.629,35.9a1.951,1.951,0,0,1-3.087,0L.408,29.261a1.952,1.952,0,0,1,.349-2.738Z",
    transform: "translate(19.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.757,10.131A1.953,1.953,0,0,0,3.5,9.782L5.147,7.647a10.577,10.577,0,0,0,1.407,4.785,6.673,6.673,0,0,1,0,6.668L5.4,21.1a14.59,14.59,0,0,0,0,14.579,1.951,1.951,0,1,0,3.378-1.955,10.679,10.679,0,0,1,0-10.669l1.158-2a10.587,10.587,0,0,0,0-10.578A6.674,6.674,0,0,1,9.063,7.7l1.612,2.084a1.951,1.951,0,1,0,3.087-2.388L8.63.758a1.951,1.951,0,0,0-3.088,0L.408,7.394A1.952,1.952,0,0,0,.757,10.131Z",
    transform: "translate(38.484)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseTransparency);
export default __webpack_public_path__ + "static/media/house-transparency.1234cd76867e20f11d3a07ffa711789f.svg";
export { ForwardRef as ReactComponent };